import styled from 'styled-components';
import { Button } from '@/components/Sections/Profile/Buttons';

export const Heading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 105%;
    color: ${(props) => props.theme.colors.white};
    text-align: center;
    margin: 30px 35px 0 35px;
    padding: 0;
    letter-spacing: -0.03em;

    max-width: 425px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-size: 40px;
        line-height: 105%;
        margin: 40px 0 0 0;
    }
`;

export const SubHeading = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    color: ${({ theme }) => theme.shades.white[50]};

    text-align: center;
    padding: 0;
    max-width: 425px;
    letter-spacing: -0.03em;
    margin: 20px 35px 0 35px;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    text-align: center;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-weight: 600;
        font-size: 20px;
        line-height: 110%;
        margin: 20px 0 0 0;
        max-width: 520px;
    }
`;

export const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 10px;
    margin-bottom: 60px;
`;

export const CTAButton = styled(Button)`
    width: 265px !important;
    margin: 30px 0 30px 0 !important;
    font-size: 18px !important;
    line-height: 18px !important;
    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        width: 295px !important;
        height: 80px !important;
        min-height: unset !important;
        margin: 40px 0 30px 0 !important;
    }
`;

export const CancelText = styled.p`
    margin: 0;
    padding: 0;
    font-family: 'Alliance No.1';
    font-style: normal;
    text-align: center;
    letter-spacing: -0.02em;
    color: rgba(255, 255, 255, 0.5);
    text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    transition: color 0.1s ease;
    font-weight: 700;
    font-size: 16px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        font-size: 18px;
    }

    &:hover {
        color: rgba(255, 255, 255, 0.9);
    }
`;

export const CrownImage = styled.img`
    height: 100px;
    width: 100px;
    min-height: 100px;
    min-width: 100px;
    margin-top: 46px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile}) {
        margin-top: 54px;
        height: 150px;
        width: 150px;
        min-height: 150px;
        min-width: 150px;
    }
`;
